import manualAddValue from './manual-add-value';

export default {
    manualAddValue
};